import { useCallback, useEffect, useState } from "react";
import confetti from "canvas-confetti";
import "./App.css";
import IndexCalculator from "./components/IndexCalculator";
import { AVERAGE_WAGE, BASE_WAGE, getFactor } from "./lib/indexMath";

function App() {
  const [, setBlackoutActive] = useState(false);
  const [confettiRun, setConfettiRun] = useState(0);
  const factor = getFactor();

  useEffect(() => {
    if (confettiRun === 0) {
      return undefined;
    }

    const end = Date.now() + 15 * 1000;
    const colors = ["#f94144", "#f8961e", "#f9c74f", "#43aa8b", "#577590", "#9b5de5"];
    let frameId;

    function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors,
        disableForReducedMotion: true,
      });

      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors,
        disableForReducedMotion: true,
      });

      if (Date.now() < end) {
        frameId = requestAnimationFrame(frame);
      }
    }

    frame();

    return () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, [confettiRun]);

  const handleBlackoutChange = useCallback((nextValue) => {
    setBlackoutActive((currentValue) => {
      if (nextValue && !currentValue) {
        setConfettiRun((currentRun) => currentRun + 1);
      }

      return nextValue;
    });
  }, []);

  return (
    <main className="app-shell">
      <div className="ambient ambient-left" />
      <div className="ambient ambient-right" />

      <section className="hero">
        <div className="hero-header">
          <p className="eyebrow">Šemora Index</p>
          <h1>Šemorův Index pro rychlé porovnání výhodnosti alkoholu.</h1>
          {/* <p className="hero-text">
            Kalkulačka zůstává funkčně stejná: porovnává objem, cenu a procenta
            alkoholu, pak výsledek upraví o mzdový faktor, aby index držel
            podobný význam i v čase.
          </p>*/}
        </div>

        <div className="hero-calculator">
          <IndexCalculator onBlackoutChange={handleBlackoutChange} />
        </div>

        <div className="hero-notes">
          <div className="note-card note-card-formula">
            <span className="note-caption">Jak se počítá faktor</span>
            <span className="note-value">
              {AVERAGE_WAGE.toLocaleString("cs-CZ")} /{" "}
              {BASE_WAGE.toLocaleString("cs-CZ")} = {factor}
            </span>
            <span className="note-label">
              Aktuální průměrná mzda dělená referenční mzdou pro zachování
              srovnatelnosti indexu.
            </span>
          </div>

          <div className="note-card">
            <span className="note-caption">Jak číst výsledek</span>
            <span className="note-value">1.0</span>
            <span className="note-label">
              Orientační hranice běžné koupě. Hodnota pod 1,0 obvykle vychází
              slaběji, nad 1,0 naopak znamená výhodnější poměr alkoholu vůči
              ceně.
            </span>
          </div>
        </div>
      </section>
    </main>
  );
}

export default App;
